import { forwardRef } from 'react';
import { Input, InputProps } from '@mui/material';

import { AppFormControl, AppFormControlProps } from 'components/AppFormControl';

interface Props extends Omit<AppFormControlProps, 'children'> {
  value: string;
  onChange?: (v: string) => void;
  componentProps?: InputProps;
}

export const AppTextForm = forwardRef<HTMLInputElement, Props>(
  ({ label, value, onChange, componentProps, ...formControlProps }, ref) => {
    return (
      <AppFormControl label={label} {...formControlProps}>
        <Input
          ref={ref}
          value={value}
          onChange={({ target }) => {
            if (onChange) onChange(target.value);
          }}
          fullWidth
          {...componentProps}
        />
      </AppFormControl>
    );
  },
);
AppTextForm.displayName = 'AppTextForm';
